export class Phone {
  phone: string;
  whatsapp: boolean;
  telegram: boolean;
  viber: boolean;
}
